<div
  (click)="openDetails()"
  [class.cursor-pointer]="hasDescription()"
  [ngClass]="theme()"
  class="staff-member-v2 flex text-left py-4 text-lg gap-3"
>
  <div [ngClass]="imageClasses()">
    <img [alt]="staffMember().name" [height]="imageSize()" [ngClass]="imageClasses()" [ngSrc]="imgUrl()"
         [width]="imageSize()"
         class="rounded-full object-cover shadow-inner"
    >
  </div>
  <div class="flex flex-col gap-0 justify-center">
    <div [class.text-lg]="theme() === 'sm'" [class.text-xl]="theme() === 'md'"
         class="text-duck-blue-2 font-bold">{{ staffMember().name }}
    </div>
    <div [class.text-base]="theme() === 'md'" [class.text-sm]="theme() === 'sm'" [innerHTML]="staffMember().description"
         class="text-grey-1 line-clamp-1"></div>
  </div>
</div>
